export const getDisplayAction = (stop) => {
    let { action, } = stop;
    if (action === 'deliver') {
        action = 'delivery';
    }
    return stop.empty ? `${action} Empty` : action;
};
export const intentMap = {
    pickup: { action: 'pickup', empty: false },
    pickup_empty: { action: 'pickup', empty: true },
    deliver: { action: 'deliver', empty: false },
    deliver_empty: { action: 'deliver', empty: true },
};
export const mapSlugToIntent = (slug) => {
    if (!slug) {
        return null;
    }
    return intentMap[slug];
};
export const mapIntentToSlug = (stop) => {
    const { action, empty, } = stop;
    if (empty) {
        return `${action}_empty`;
    }
    return action;
};
export const getStopLocation = (stop) => {
    const locations = stop.location || [];
    const location = locations.length > 0 ? locations[0] : { name: '', address: '' };
    return location;
};
